import { yupResolver } from '@hookform/resolvers/yup'
import { MAX_DESCRIPTION_LENGTH, MAX_TITLE_LENGTH } from 'features/rentals/rentals.config'
import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

export const useRentalValidationSchema = () => {
	const { t } = useTranslation()

	const rentalValidationSchema = yup.object({
		title: yup
			.string()
			.max(MAX_TITLE_LENGTH, t('Max {{ count }} letters', { count: MAX_TITLE_LENGTH }))
			.optional(),
		description: yup
			.string()
			.max(MAX_DESCRIPTION_LENGTH, t('Max {{ count }} letters', { count: MAX_DESCRIPTION_LENGTH }))
			.optional(),
		duration: yup.string().required(t('Duration is required')),
		price: yup.object({
			amount: yup.string().required(t('Price is required'))
		}),
		original_price: yup.object({
			amount: yup.string().required(t('Original price is required'))
		}),
		currency: yup.object({
			value: yup.string().required(t('Currency is required'))
		})
	})

	return yupResolver(rentalValidationSchema)
}
